import { v4 as uuidv4 } from 'uuid';
export default () => {
  const uuid = uuidv4()
  return {
    $id: uuid,
    valueType: 'inputSearch',
    FormItemProps: {
      label: '搜索输入框',
      name: uuid,
    },
  }
};
